import { useState } from "react";
import { CreateBase, Form, useGetIdentity, useNotify, type MutationMode } from "ra-core";
import { Card, CardContent } from "@/components/ui/card";

import { ContactInputs } from "./ContactInputs";
import { FormToolbar } from "../layout/FormToolbar";
import {
  cleanupContactForCreate,
  defaultEmailJsonb,
  defaultPhoneJsonb,
} from "./contactModel";
import type { DuplicateDetectionResult } from "../misc/ContactDuplicateRadar";

export const ContactCreate = ({
  mutationMode,
}: {
  mutationMode?: MutationMode;
}) => {
  const { identity } = useGetIdentity();
  const notify = useNotify();
  const [duplicateStatus, setDuplicateStatus] = useState<DuplicateDetectionResult | null>(null);

  return (
    <CreateBase
      redirect="show"
      transform={(data) => {
        if (duplicateStatus?.isHardDuplicate) {
          notify(duplicateStatus.reason, { type: "error" });
          throw new Error(duplicateStatus.reason);
        }
        return cleanupContactForCreate(data);
      }}
      mutationMode={mutationMode}
    >
      <div className="mt-2 flex lg:mr-72">
        <div className="flex-1">
          <Form
            defaultValues={{
              sales_id: identity?.id,
              email_jsonb: defaultEmailJsonb,
              phone_jsonb: defaultPhoneJsonb,
            }}
          >
            <Card>
              <CardContent>
                <ContactInputs onDuplicateChange={setDuplicateStatus} />
                <div className="flex flex-col sm:flex-row justify-between items-center pt-2 gap-2">
                  {duplicateStatus?.isHardDuplicate ? (
                    <div className="text-xs text-red-600 dark:text-red-400 font-semibold pl-1">
                      ⚠️ Exact duplicate detected — creation disabled to protect team CRM data.
                    </div>
                  ) : <div />}
                  <FormToolbar disabled={duplicateStatus?.isHardDuplicate} />
                </div>
              </CardContent>
            </Card>
          </Form>
        </div>
      </div>
    </CreateBase>
  );
};
